module.exports = __webpack_public_path__ + "img/key_features--mobilization.c4df6946.png";